<app-table
    #protocolsTable
    [translatePrefix]="prefix"
    tableKey="workProtocolsWidget"
    [columns]="columns"
    [hideCheckboxes]="true"
    [showColumnVisiblity]="true"
    [rowExpansion]="rowExpansion"
    [expandedRowKeys]="store.expandedKeys()"
    [gridData]="store.worksData()"
    [additionalFilter]="additionalFilter()"
    [refreshCallbackFragment]="getProtocolWidgetWorksFrag"
    [refreshCallback]="store.api.getWorks"
    [defaultSorters]="[{ column: 'dateFrom', direction: 'DESC' }]"
    (detailCallback)="detailWork($event)"
    (deleteCallbackWithEvent)="deleteWork($event)"
>
    <ng-template pTemplate="applications" let-item="item">
        {{ item.dateFrom | datesFormatDuration:item.dateTo }}
    </ng-template>
    <ng-template pTemplate="tags" let-data="data">
        <div class="flex gap-x-small">
            @for (tag of data; track $index) {
                <app-tag [label]="tag"></app-tag>
            }
        </div>
    </ng-template>
    <ng-template pTemplate="workType" let-data="data">
        @if (socialOnlyWorkTypes.includes(data)) {
            {{ 'workData.common.enum.type.' + data | translate }}
        } @else if (data === 'offer') {
            {{ prefix + 'fields.offer' | translate }}
        }
    </ng-template>
    <ng-template #rowExpansion let-item="item">
        <div class="flex-column" style="max-width: 100vw;">
            @if (item.protocol !== '') {
                <div [innerHTML]="item.protocol"></div>
            }
            @for (offer of item.filledOffersProtocols; track $index; let i = $index; ) {
                <div class="flex-column">
                    @if (item.protocol !== '' || i > 0) {
                        <p-divider></p-divider>
                    }
                    <div class="flex gap-small align-items-center">
                        <p-chip
                            [label]="$any(offer.serviceOffer) | formatOfferDuration:true:offer.applications"
                            [ngStyle]="{ 'background-color': offer.serviceOffer.color || DEFAULT_TAG_COLOR, 'border-radius': '16px', color: (offer.serviceOffer.color || DEFAULT_TAG_COLOR) | colorContrast }"
                        ></p-chip>
                        <div>-</div>
                        <div>{{ offer.serviceOffer.name }}</div>
                        @if (offer.typeInfo; as typeInfo) {
                            <p-divider layout="vertical"></p-divider>
                            <app-icon
                                [icon]="typeInfo.icon"
                                [svgStyle]="{ 'fill': 'var(' + typeInfo.color + ')' }"
                            ></app-icon>
                            <div>-</div>
                            <div>{{ typeInfo.tooltip }}</div>
                        }
                        @if (offer.presenceInfo; as presenceInfo) {
                            <p-divider layout="vertical"></p-divider>
                            <app-icon
                                [icon]="presenceInfo.icon"
                                [svgStyle]="{ 'fill': 'var(' + presenceInfo.color + ')' }"
                            ></app-icon>
                            <div>-</div>
                            <div>{{ presenceInfo.tooltip }}</div>
                        }
                        @if (offer.tags.length) {
                            <p-divider layout="vertical"></p-divider>
                        }
                        <div class="flex gap-small align-items-center">
                            @for (tag of offer.tags; track $index) {
                                <app-tag [label]="tag"></app-tag>
                            }
                        </div>
                    </div>
                    <div class="pt-2" [innerHTML]="offer.protocol"></div>
                </div>
            }
        </div>
    </ng-template>
</app-table>
